/**
 * Cart Upsell — Smart Complementary Recommendations
 * Sam's Store UAE — FIXED v3
 *
 * FIXES:
 *  1. API URL fix: no section_id (returns pure JSON)
 *  2. Event detection: MutationObserver watches cart-drawer .active class (reliable Dawn hook)
 *  3. Cart filter: fetches /cart.js to get current product IDs (no broken DOM selectors)
 */

(function () {
    'use strict';

    var RECS_URL = '/recommendations/products';

    // ─── Helpers ───────────────────────────────────────────────────────────────

    function money(cents) {
        return 'AED\u00a0' + Number((cents / 100).toFixed(0)).toLocaleString('en-AE');
    }

    function buildCard(product) {
        var imgSrc = '';
        if (product.featured_image) {
            imgSrc = product.featured_image + (product.featured_image.indexOf('?') !== -1 ? '&' : '?') + 'width=120';
        }
        var title = (product.title || '').substring(0, 36);
        return '<li class="cart-upsell__item">'
            + '<a href="' + product.url + '" class="cart-upsell__link" tabindex="0">'
            + (imgSrc ? '<img src="' + imgSrc + '" alt="" class="cart-upsell__img" width="56" height="56" loading="lazy" decoding="async">' : '')
            + '<span class="cart-upsell__info">'
            + '<span class="cart-upsell__name">' + title + '</span>'
            + '<span class="cart-upsell__price">' + money(product.price) + '</span>'
            + '</span>'
            + '</a>'
            + '</li>';
    }

    // ─── Fetch current cart product IDs via /cart.js ───────────────────────────

    function getCartProductIds(callback) {
        fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                var ids = (cart.items || []).map(function (i) { return String(i.product_id); });
                callback(ids);
            })
            .catch(function () { callback([]); });
    }

    // ─── Fetch recs and render ─────────────────────────────────────────────────

    function fetchAndRender(productId) {
        var strip = document.getElementById('cart-upsell-strip');
        var list = document.getElementById('cart-upsell-list');
        if (!strip || !list) return;
        if (strip.dataset.loaded === String(productId)) return;

        // ✅ FIX 1: Use 'related' intent by default — works for all products without manual configuration.
        // 'complementary' requires per-product setup in Shopify Admin → causes 422 errors when not set.
        var url = RECS_URL + '?product_id=' + productId + '&limit=6&intent=related';

        fetch(url)
            .then(function (r) {
                if (!r.ok) return Promise.reject(r.status);
                return r.json();
            })
            .then(function (data) {
                // If 'related' returns empty, try 'complementary' as secondary attempt
                var products = data.products || [];
                if (products.length === 0) {
                    return fetch(RECS_URL + '?product_id=' + productId + '&limit=6&intent=complementary')
                        .then(function (r2) { return r2.ok ? r2.json() : { products: [] }; });
                }
                return data;
            })
            .then(function (data) {
                var products = (data.products || []).filter(function (p) {
                    return String(p.id) !== String(productId);
                });

                if (products.length === 0) {
                    strip.style.display = 'none';
                    return;
                }

                // ✅ FIX 3: Use /cart.js to get in-cart product IDs
                getCartProductIds(function (cartIds) {
                    var filtered = cartIds.length > 0
                        ? products.filter(function (p) { return cartIds.indexOf(String(p.id)) === -1; })
                        : products;

                    if (filtered.length === 0) {
                        strip.style.display = 'none';
                        return;
                    }

                    list.innerHTML = filtered.slice(0, 3).map(buildCard).join('');
                    strip.style.display = '';
                    strip.dataset.loaded = String(productId);
                });
            })
            .catch(function () {
                if (strip) strip.style.display = 'none';
            });
    }

    function tryLoad() {
        var strip = document.getElementById('cart-upsell-strip');
        if (!strip) return;
        var productId = strip.dataset.productId;
        if (!productId || productId === '0') return;
        fetchAndRender(productId);
    }

    // ─── Init ─────────────────────────────────────────────────────────────────

    function init() {
        // ✅ FIX 2: MutationObserver on cart-drawer element watching for .active class
        // Dawn's CartDrawer.open() does: this.classList.add('animate', 'active')
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && window.MutationObserver) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (m) {
                    if (m.type === 'attributes' && m.attributeName === 'class') {
                        var el = m.target;
                        var isActive = el.classList.contains('active');
                        // Reset loaded flag when drawer closes so next open re-fetches for new cart state
                        if (!isActive) {
                            var strip = document.getElementById('cart-upsell-strip');
                            if (strip) strip.dataset.loaded = '';
                        } else {
                            setTimeout(tryLoad, 200);
                        }
                    }
                });
            });
            observer.observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
        }

        // Also listen for product-form add-to-cart which fires BEFORE the drawer opens
        document.addEventListener('click', function (e) {
            var addBtn = e.target.closest('[data-type="add-to-cart-form"] [type="submit"], .quick-add__submit');
            if (addBtn) {
                // Reset so upsell re-fetches after cart changes
                setTimeout(function () {
                    var strip = document.getElementById('cart-upsell-strip');
                    if (strip) strip.dataset.loaded = '';
                }, 800);
            }
        });

        // Fallback: on page load in case drawer starts open
        tryLoad();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
